<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>行動支付總查詢</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">起始時間：</h4>
        <DateSelect ref="startTime" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">結束時間：</h4>
        <DateSelect ref="endTime" :isEndTime="true"></DateSelect>
      </div>
    </div>
    <el-row :gutter="10" style="margin-bottom: 1rem">
      <el-col :span="12">
        <h4 class="col-md-2">搜尋關鍵字:</h4>
        <input
          v-model="kw"
          type="text"
          required="required"
          class="search-input inputstyle fontSize16"
          placeholder="隊編/呼號、乘客電話、司機姓名"
        />
        <el-button type="primary" @click="searchPayList" :loading="btnLoading">
          搜尋
        </el-button>
      </el-col>
      <el-col :span="3">
        <h4 class="col-md-12">
          <i class="fa fa-user"></i>
          派車單總數:
          <span class="red_textcolor">{{ total }}</span>
        </h4>
      </el-col>
      <el-col :span="1">
        <el-button
          type="primary"
          :loading="loading"
          @click="download"
          :disabled="loading"
        >
          下載excel總表
        </el-button>
      </el-col>
    </el-row>

    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_content">
          <ul class="nav nav-tabs fontSize20" id="myTab" role="tablist">
            <li class="nav-item active"></li>
            <li class="nav-item active">
              <a
                class="nav-link"
                id="credit-card-tab"
                data-toggle="tab"
                href="#nav-credit-card"
                role="tab"
                aria-controls="creditCard"
                aria-expanded="true"
                @click="setPicked('creditCard')"
              >
                信用卡
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="line-pay-tab"
                data-toggle="tab"
                href="#line-pay"
                role="tab"
                aria-controls="linepay"
                aria-selected="false"
                @click="setPicked('linePay')"
              >
                LinePay
              </a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade active in"
              id="nav-credit-card"
              role="tabpanel"
              aria-labelledby="credit-card-tab"
            >
              <div class="row">
                <div class="col-md-3">
                  <label>
                    <select
                      v-model="npp"
                      @change="getList"
                      name="datatable-checkbox_length"
                      aria-controls="datatable-checkbox"
                      class="form-control input-sm"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped jambo_table bulk_action">
                  <thead>
                    <tr class="headings">
                      <th class="column-title word_center">訂單類型</th>
                      <th class="column-title word_center">訂單編號</th>
                      <th class="column-title word_center">隊編/呼號</th>
                      <th class="column-title word_center">姓名</th>
                      <th class="column-title word_center">付款方式</th>
                      <th class="column-title word_center">付款金額</th>
                      <th class="column-title word_center">乘客付款名字</th>
                      <th class="column-title word_center">司機領款</th>
                      <th class="column-title word_center">付款時間</th>
                      <th class="column-title word_center">退款金額</th>
                      <th class="column-title word_center">退款時間</th>
                      <th class="column-title word_center">退款備註</th>
                      <th class="column-title word_center">退款按鈕</th>
                      <th class="column-title word_center">領款按鈕</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row, index) in list">
                      <tr
                        v-if="total > 0"
                        v-bind:class="{
                          even: index % 2 == 0,
                          odd: index % 2 != 0,
                        }"
                        class="pointer"
                      >
                        <td class="word_center">{{ row.type }}</td>
                        <td class="word_center">
                          {{
                            row.type === '預約單'
                              ? row.reservationId
                              : row.transactionId
                          }}
                        </td>
                        <td class="word_center">{{ row.driverCallNumber }}</td>
                        <td class="word_center">{{ row.driverName }}</td>
                        <td class="word_center">信用卡</td>
                        <td class="word_center">{{ row.amount }}</td>
                        <td class="word_center">
                          {{ row.passengerName }}/{{ row.passengerPhone }}
                        </td>
                        <td class="word_center">{{ row.driverReceiveDate }}</td>
                        <td class="word_center">{{ row.createdAt }}</td>
                        <td class="word_center">{{ row.refundAmount }}</td>
                        <td class="word_center">{{ row.refundDate }}</td>
                        <td class="word_center">{{ row.refundNote }}</td>
                        <td class="word_center">
                          <el-button
                            type="danger"
                            v-if="
                              checkPayTimeWithInTherrDays(
                                row.createdAt,
                                row.refundDate,
                              )
                            "
                            @click="
                              openModal(
                                row.type === '預約單'
                                  ? row.reservationId
                                  : row.transactionId,
                                0,
                                row.tradeId,
                                row.amount,
                              )
                            "
                            round
                          >
                            退款
                          </el-button>
                        </td>
                        <td class="word_center">
                          <el-button
                            type="primary"
                            v-if="!row.driverReceive"
                            round
                            @click="updateReceive(row.tradeId, 0)"
                          >
                            領款
                          </el-button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div class="pull-right">
                <ul class="pagination">
                  <li v-bind:class="{ disabled: page == 1 }">
                    <a
                      href="javascript:;"
                      @click="clickNewPage(1)"
                      v-bind:class="{ active: page == 1 }"
                    >
                      第一頁
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="clickNewPage(pages_show_list[0] - 1)"
                      v-show="page - 2 > 1 && pages_show_list[0] - 1 != 1"
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-for="n in pages_show_list"
                    v-bind:class="{ active: n == page }"
                    @click="clickNewPage(n)"
                  >
                    <a href="javascript:;" ng-bind="n">{{ n }}</a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="clickNewPage(pages_show_list[4] + 1)"
                      v-show="
                        page + 2 < totalPage &&
                        pages_show_list[4] + 1 < totalPage
                      "
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-show="totalPage > 1"
                    v-bind:class="{ disabled: page == totalPage }"
                  >
                    <a
                      href="javascript:;"
                      @click="clickNewPage(totalPage)"
                      v-bind:class="{ active: page == totalPage }"
                    >
                      最後一頁
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="tab-pane fade in"
              id="line-pay"
              role="tabpanel"
              aria-labelledby="line-pay-tab"
            >
              <div class="row">
                <div class="col-md-3">
                  <label>
                    <select
                      v-model="npp"
                      @change="getList"
                      name="datatable-checkbox_length"
                      aria-controls="datatable-checkbox"
                      class="form-control input-sm"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped jambo_table bulk_action">
                  <thead>
                    <tr class="headings">
                      <th class="column-title word_center">訂單類型</th>
                      <th class="column-title word_center">訂單編號</th>
                      <th class="column-title word_center">隊編/呼號</th>
                      <th class="column-title word_center">姓名</th>
                      <th class="column-title word_center">付款方式</th>
                      <th class="column-title word_center">付款金額</th>
                      <th class="column-title word_center">乘客付款名字</th>
                      <th class="column-title word_center">司機領款</th>
                      <th class="column-title word_center">付款時間</th>
                      <th class="column-title word_center">退款金額</th>
                      <th class="column-title word_center">退款時間</th>
                      <th class="column-title word_center">退款備註</th>
                      <th class="column-title word_center">退款按鈕</th>
                      <th class="column-title word_center">領款按鈕</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row, index) in linePayList">
                      <tr
                        v-if="ltotal > 0"
                        v-bind:class="{
                          even: index % 2 == 0,
                          odd: index % 2 != 0,
                        }"
                        class="pointer"
                      >
                        <td class="word_center">{{ row.type }}</td>
                        <td class="word_center">
                          {{
                            row.type === '預約單'
                              ? row.reservationId
                              : row.transactionId
                          }}
                        </td>
                        <td class="word_center">{{ row.driverCallNumber }}</td>
                        <td class="word_center">{{ row.driverName }}</td>
                        <td class="word_center">Line pay</td>
                        <td class="word_center">{{ row.amount }}</td>
                        <td class="word_center">
                          {{ row.passengerName }}/{{ row.passengerPhone }}
                        </td>
                        <td class="word_center">{{ row.driverReceiveDate }}</td>
                        <td class="word_center">{{ row.createdAt }}</td>
                        <td class="word_center">{{ row.refundAmount }}</td>
                        <td class="word_center">{{ row.refundDate }}</td>
                        <td class="word_center">{{ row.refundNote }}</td>
                        <td class="word_center">
                          <el-button
                            type="danger"
                            v-if="
                              checkPayTimeWithInTherrDays(
                                row.createdAt,
                                row.refundDate,
                              )
                            "
                            @click="
                              openModal(
                                row.type === '預約單'
                                  ? row.reservationId
                                  : row.transactionId,
                                1,
                                row.tradeId,
                                row.amount,
                              )
                            "
                            round
                          >
                            退款
                          </el-button>
                        </td>
                        <td class="word_center">
                          <el-button
                            type="primary"
                            v-if="!row.driverReceive"
                            round
                            @click="updateReceive(row.tradeId, 1)"
                          >
                            領款
                          </el-button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div class="pull-right">
                <ul class="pagination">
                  <li v-bind:class="{ disabled: lpage == 1 }">
                    <a
                      href="javascript:;"
                      @click="clickLinePayNewPage(1)"
                      v-bind:class="{ active: lpage == 1 }"
                    >
                      第一頁
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="
                        clickLinePayNewPage(line_pay_pages_show_list[0] - 1)
                      "
                      v-show="
                        lpage - 2 > 1 && line_pay_pages_show_list[0] - 1 != 1
                      "
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-for="n in line_pay_pages_show_list"
                    v-bind:class="{ active: n == lpage }"
                    @click="clickLinePayNewPage(n)"
                  >
                    <a href="javascript:;" ng-bind="n">{{ n }}</a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="
                        clickLinePayNewPage(line_pay_pages_show_list[4] + 1)
                      "
                      v-show="
                        lpage + 2 < ltotalPage &&
                        line_pay_pages_show_list[4] + 1 < ltotalPage
                      "
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-show="ltotalPage > 1"
                    v-bind:class="{ disabled: lpage == ltotalPage }"
                  >
                    <a
                      href="javascript:;"
                      @click="clickLinePayNewPage(ltotalPage)"
                      v-bind:class="{ active: lpage == ltotalPage }"
                    >
                      最後一頁
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="refundModal" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">退款備註</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <el-form label-position="left" label-width="80px">
              <el-form-item label="退款備註">
                <el-input v-model="refundNote"></el-input>
              </el-form-item>
              <el-form-item label="退款金額">
                <el-input v-model="refundAmount"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="closeModal"
            >
              關閉
            </button>
            <button type="button" class="btn btn-primary" @click="refund">
              退款
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateSelect from '../../components/tool/DateSelect'
import API from '../../assets/js/libs/API'
import moment from 'moment'
import { cookies } from '@/utils/cookies'
import axios from 'axios'

export default {
  name: 'PayList',
  components: {
    DateSelect,
  },
  data() {
    return {
      list: [],
      npp: 25,
      page: 1,
      kw: '',
      total: 0,
      totalPage: 0,
      startTime: moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
      endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      //linepay
      linePayList: [],
      lnpp: 25,
      lpage: 1,
      ltotal: 0,
      ltotalPage: 0,
      task: 'creditCard',
      refundNote: '',
      tradeId: '',
      type: '',
      orderId: '',
      loading: false,
      btnLoading: false,
      refundAmount: 0,
    }
  },
  mounted() {
    this.getList('creditCard')
  },
  methods: {
    download() {
      this.loading = true
      axios
        .get(`${API.getAPIUrl}mobilePay/download`, {
          responseType: 'blob',
          params: {
            startTime: this.$refs.startTime.getDate(),
            endTime: this.$refs.endTime.getDate(),
          },
        })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(blob)
          let startTime = this.$refs.startTime.getDate()
          let endTime = this.$refs.endTime.getDate()
          downloadElement.href = href
          downloadElement.download = `${startTime}~${endTime}行動支付.xlsx`
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.loading = false
        })
        .catch((error) => {
          // alert('不得超過一個月或時間錯誤')
          this.loading = false
          console.log(error)
        })
    },
    openModal(orderId, type, id, amount) {
      this.type = type
      this.tradeId = id
      this.orderId = orderId
      this.refundAmount = amount
      $('#refundModal').modal({ backdrop: 'static', keyboard: false })
    },
    closeModal() {
      this.type = ''
      this.tradeId = ''
      this.orderId = ''
      this.refundNote = ''
    },
    checkPayTimeWithInTherrDays(time, refundTime) {
      let current = moment().format('YYYY-MM-DD HH:mm:ss')
      let ago = moment().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss')
      if (refundTime === null) {
        return moment(time).isBetween(ago, current)
      }
      return false
    },
    clickNewPage(page) {
      this.page = page
      this.getList('creditCard')
    },
    searchPayList() {
      let start_time = this.$refs.startTime.getDate()
      let end_time = this.$refs.endTime.getDate()
      if (moment(start_time).isAfter(end_time)) return alert('時間錯誤')
      this.startTime = moment(start_time).format('YYYY-MM-DD HH:mm:ss')
      this.endTime = moment(end_time).format('YYYY-MM-DD HH:mm:ss')

      this.getList()
    },
    clickLinePayNewPage(page) {
      this.lpage = page
      this.getList()
    },
    setPicked(val) {
      this.task = val
      this.getList()
    },
    updateReceive(tradeId, type) {
      console.log(tradeId)
      console.log(type)

      if (tradeId === '') {
        alert('錯誤，再試一次')
        return
      }
      let payload = {
        type: type,
      }
      API.put(`mobilePay/update/?recTrade_id=${tradeId}`, payload)
        .then((res) => {
          if (res.success) {
            this.$msg('更新領款')
            this.getList()
            return
          }
          this.$msg('更新領款失敗')
        })
        .catch((err) => {
          this.$msg('連線異常，再試一次')
        })
    },
    refund() {
      if (this.tradeId === '') {
        alert('錯誤，再試一次')
        return
      }
      let payload = {
        recTradeId: this.tradeId,
        refundNote: this.refundNote + `/${cookies.get('GladName')}`,
        type: this.type,
        amount: this.refundAmount,
      }
      API.post(`mobilePay/refund`, payload)
        .then((res) => {
          if (res.success) {
            alert('退款成功')
            $('#refundModal').modal('hide')
            this.getList()
          } else {
            alert(`退款失敗-${res.result}`)
          }
        })
        .catch((err) => {
          this.$msg('連線異常，再試一次')
        })
    },
    getList() {
      this.btnLoading = true
      API.get(
        `mobilePay/list/?npp=${this.npp}&page=${this.page}&task=${this.task}&keyword=${this.kw}&startTime=${this.startTime}&endTime=${this.endTime}`,
      )
        .then((res) => {
          this.btnLoading = false
          if (res.result === 'err') return
          if (this.task === 'creditCard') {
            this.list = res.result.list
            this.total = res.result.total
            this.totalPage = Math.ceil(res.result.total / this.npp)
          }
          if (this.task === 'linePay') {
            // console.log('=========',res.result.list)
            this.linePayList = res.result.list
            this.ltotal = res.result.total
            this.ltotalPage = Math.ceil(res.result.total / this.lnpp)
          }
          // this.loader.hide()
        })
        .catch((err) => {
          this.btnLoading = false
          this.loader.hide()
          this.$msg('網路不穩定請在操作一次')
          console.log('reservationBill', err)
        })
    },
  },
  computed: {
    pages_show_list: function () {
      var pages_show_list = []
      var totalPage = this.totalPage
      var newCurrent = this.page
      if (totalPage < 7) {
        for (var i = 2; i < totalPage; i++) {
          pages_show_list.push(i)
        }
      } else {
        if (newCurrent <= 4) {
          for (var i = 2; i < 7; i++) {
            pages_show_list.push(i)
          }
        } else if (newCurrent <= totalPage && newCurrent >= totalPage - 3) {
          for (var i = totalPage - 5; i < totalPage; i++) {
            pages_show_list.push(i)
          }
        } else {
          for (var i = -2; i < 3; i++) {
            pages_show_list.push(newCurrent + i)
          }
        }
      }
      return pages_show_list
    },
    line_pay_pages_show_list: function () {
      var pages_show_list = []
      var totalPage = this.ltotalPage
      var newCurrent = this.lpage
      if (totalPage < 7) {
        for (var i = 2; i < totalPage; i++) {
          pages_show_list.push(i)
        }
      } else {
        if (newCurrent <= 4) {
          for (var i = 2; i < 7; i++) {
            pages_show_list.push(i)
          }
        } else if (newCurrent <= totalPage && newCurrent >= totalPage - 3) {
          for (var i = totalPage - 5; i < totalPage; i++) {
            pages_show_list.push(i)
          }
        } else {
          for (var i = -2; i < 3; i++) {
            pages_show_list.push(newCurrent + i)
          }
        }
      }
      return pages_show_list
    },
  },
}
</script>
<style scoped>
.search-input {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/mobilePay/payList.vue